import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

// نافذة ملاحظة لإكمال المهمة (اختياري) أو رفضها (إلزامي).
export const TaskNoteDialog = ({ state, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  useEffect(() => { setText(""); }, [state]);
  if (!state) return null;
  const isReject = state.mode === "reject";
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-background/80 p-4" data-testid="task-note-dialog" onClick={onClose}>
      <NeuCard className="grid w-full max-w-md gap-4" onClick={(e) => e.stopPropagation()}>
        <h3 className={`text-lg font-black ${isReject ? "text-rose-600" : "text-emerald-600"}`}>
          {t(isReject ? "tasks.form.rejectTitle" : "tasks.form.completeTitle")}
        </h3>
        <textarea data-testid="task-note-input" value={text} onChange={(e) => setText(e.target.value)} rows={4}
          placeholder={t(isReject ? "tasks.form.noteReject" : "tasks.form.noteComplete")}
          className="w-full resize-none rounded-2xl bg-background p-3 text-sm shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring" />
        <div className="flex flex-wrap gap-3">
          <NeuButton variant="primary" data-testid="task-note-submit" disabled={isReject && !text.trim()}
            onClick={() => { if (isReject && !text.trim()) return; onSubmit(text.trim()); }}>
            {t(isReject ? "tasks.actions.reject" : "tasks.actions.complete")}
          </NeuButton>
          <NeuButton data-testid="task-note-cancel" onClick={onClose}>{t("common.cancel")}</NeuButton>
        </div>
      </NeuCard>
    </div>
  );
};
